import axios, { endpoints } from '../../utils/axios'; // import dispatch from store

// ----------------------------------------------------------------------


export const createUser = async (userData) => {
  try {
    const response = await axios.post(endpoints.user, userData);
    return response.data.user;
  } catch (error) {
    throw new Error(error?.response?.data?.message || error.message);
  }
}

// ----------------------------------------------------------------------
export const updateUser = async (userData) => {
  try {
    // If userData is FormData, axios will automatically set Content-Type to multipart/form-data
    const config = userData instanceof FormData 
      ? { headers: { 'Content-Type': 'multipart/form-data' } }
      : {};
    
    const response = await axios.put(endpoints.user, userData, config);
    return response.data.user;
  } catch (error) {
    throw new Error(error?.response?.data?.message || error.message);
  }
}

// ----------------------------------------------------------------------
/**
 * Save progress through guided setup.
 * @param {{status?: 'active'|'done'|'skipped', goal?: 'cross_list'|'single_marketplace'|null}} progress
 * @returns {Promise<{onboardingStatus: string, onboardingGoal: string|null}>}
 */
export const updateOnboarding = async (progress) => {
  try {
    const response = await axios.patch(endpoints.onboarding, progress);
    return response.data;
  } catch (error) {
    throw new Error(error?.response?.data?.message || error.message);
  }
}

// ----------------------------------------------------------------------
export const getUser = async () => {
  try {
    const response = await axios.get(endpoints.user);
    return response.data.user;

  } catch (error) {
    throw new Error(error?.response?.data?.message || error.message);
  }
}

// ----------------------------------------------------------------------

